export const enum AuthEndpoints {
  LOGIN = '/auth/login',
  REGISTER = '/auth/register',
  RESET_PASSWORD = '/auth/resetPassword',
  LOGOUT = '/auth/signout',
  REFRESH = '/auth/refresh-token',
  MFA_VERIFICATION = '/auth/mfa',
  USER_AUTH = '/auth/user',
  FORGOT_PASSWORD = '/auth/forgotPassword',
  TERMS_OF_SERVICES = '/users/updateUserTermService'
}
